import React from "react";
import styles from './SaleDetails.module.scss';
import {IProduct} from 'data/interfaces/products';
import {MDBCol, MDBRow} from 'mdbreact';
import {IOrder} from 'data/interfaces/orders';

import {getVoucherName} from 'data/redux/selectors/productSelector';
import {voucherTypeToLabel} from "../../../../../../../../../data/enums/products";

export interface IPreSaleConclusionProps {
  product?: IProduct;
  order?: IOrder;
}

const SaleDetails = (props: IPreSaleConclusionProps) => (
  <div className={styles.saleDetailsContainer}>
    <MDBRow className={styles.type}>
      <MDBCol className={styles.label} sm="3">
        סוג:
      </MDBCol>
      <MDBCol className={`${styles.value} value disableWordBreak`}
              sm="9">
        {voucherTypeToLabel[props.product.voucherDetails.type]}
      </MDBCol>
    </MDBRow>
    <MDBRow className={styles.type}>
      <MDBCol className={`${styles.label} label`}
              sm="3">
        חברה:
      </MDBCol>
      <MDBCol className={`${styles.value} value disableWordBreak`}
              sm="9">
        {getVoucherName(props.product)}
      </MDBCol>
    </MDBRow>
  </div>
);

SaleDetails.defaultProps = {
  product: {},
};

export default React.memo(SaleDetails);
